import {AppService} from "@/services/app";

const state = {

};

const getters = {

};

const actions = {
    async sendRequestForm({dispatch}, requestForm) {
        return await AppService.sendRequestForm(requestForm);
    },
};

const mutations = {

};

export default {
    state,
    getters,
    actions,
    mutations
}
